// src/components/PropertyPage/Utils/PropertyBookingSkeleton.js
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const PropertyBookingSkeleton = () => {
  return (
    <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0">
      <div className="PropertyBookingSkeleton">
        {/* Precio */}
        <div className="PropertyBookingSkeleton__price">
          <Skeleton height={28} width="40%" />
          <Skeleton height={16} width="60%" />
        </div>
        
        {/* Calendario */}
        <div className="PropertyBookingSkeleton__calendar">
          <Skeleton height={40} />
          <Skeleton height={40} />
        </div>
        
        {/* Botón de reserva */}
        <div className="PropertyBookingSkeleton__button">
          <Skeleton height={48} />
        </div>
        
        {/* Información adicional */}
        <div className="PropertyBookingSkeleton__info">
          <Skeleton height={16} />
          <Skeleton height={16} width="80%" />
        </div>
      </div>
    </SkeletonTheme>
  );
};

export default PropertyBookingSkeleton;